import { render, staticRenderFns } from "./AbkCompetenceForm.vue?vue&type=template&id=0bfd0426&scoped=true&"
import script from "./AbkCompetenceForm.vue?vue&type=script&lang=js&"
export * from "./AbkCompetenceForm.vue?vue&type=script&lang=js&"
import style0 from "./AbkCompetenceForm.vue?vue&type=style&index=0&id=0bfd0426&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfd0426",
  null
  
)

export default component.exports